import React from "react";
import Header1 from "./Header1";
import Header2 from "./Header2";
import Body12 from "./Body12";
import Footer1 from "./Footer1";
import Footer2 from "./Footer2";


function PageProjekty() {

  return (
    <div>
      <Header1/>
      <Header2/>
      <Body12/>
      <Footer1/>
      <Footer2/>
    </div>
  );
}

export default PageProjekty;
